export interface MessageModel {
  user: number
  type: 'in' | 'out'
  text: string
  time: string
  template?: boolean
}

const defaultMessages: Array<MessageModel> = [
  {
    user: 4,
    type: 'in',
    text: 'How likely are you to recommend our company to your friends and family ?',
    time: '2 mins',
  },
  {
    user: 2,
    type: 'out',
    text: 'Hey there, we’re just writing to let you know that you’ve been subscribed to a repository on GitHub.',
    time: '5 mins',
  },
  {
    user: 4,
    type: 'in',
    text: 'Ok, Understood!',
    time: '1 Hour',
  },
  {
    user: 2,
    type: 'out',
    text: 'You’ll receive notifications for all issues, pull requests!',
    time: '2 Hours',
  },
  {
    user: 4,
    type: 'in',
    text: 'You can unwatch this repository immediately by clicking here: <a href="https://keenthemes.com">Keenthemes.com</a>',
    time: '3 Hours',
  },
  {
    user: 2,
    type: 'out',
    text: 'Most purchased Business courses during this sale!',
    time: '4 Hours',
  },
  {
    user: 4,
    type: 'in',
    text: 'Company BBQ to celebrate the last quater achievements and goals. Food and drinks provided',
    time: '5 Hours',
  },
  {
    template: true,
    user: 2,
    type: 'out',
    text: '',
    time: 'Just now',
  },
  {
    template: true,
    user: 4,
    type: 'in',
    text: 'Right before vacation season we have the next Big Deal for you.',
    time: 'Just now',
  },
]

export interface PermissionModel {
  initials?: {label: string; state: 'warning' | 'danger' | 'primary' | 'success' | 'info'}
  name: string
  assigned_to: string
  created_date: string
}
const defaultPermissions: Array<PermissionModel> = [
  {
    name: 'Emma Smith',
    assigned_to: 'admin',
    created_date: '15 Jul 2024, 10:10 am'
  },
]

export interface UserInfoModel {
  initials?: {label: string; state: 'warning' | 'danger' | 'primary' | 'success' | 'info'}
  name: string
  avatar?: string
  email: string
  mobile?: string
  visiting_center?: string
  visit_date?: string
  tantative_joining?: string
  position: string
  online: boolean
}

const defaultUserInfos: Array<UserInfoModel> = [
  {
    name: 'Emma Smith',
    avatar: 'avatars/300-6.jpg',
    email: 'e.smith@kpmg.com.au',
    mobile: '9928000011',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    position: 'Art Director',
    online: false,
  },
  {
    name: 'Melody Macy',
    initials: {label: 'M', state: 'danger'},
    email: 'melody@altbox.com',
    mobile: '9928000011',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    position: 'Marketing Analytic',
    online: true,
  },
  {
    name: 'Max Smith',
    avatar: 'avatars/300-1.jpg',
    email: 'max@kt.com',
    mobile: '9928000011',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    position: 'Software Enginer',
    online: false,
  },
  {
    name: 'Sean Bean',
    avatar: 'avatars/300-5.jpg',
    email: 'sean@dellito.com',
    mobile: '9928000011',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    position: 'Web Developer',
    online: false,
  },
  {
    name: 'Brian Cox',
    avatar: 'avatars/300-25.jpg',
    email: 'brian@exchange.com',
    position: 'UI/UX Designer',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    mobile: '9928000011',
    online: false,
  },
  {
    name: 'Mikaela Collins',
    initials: {label: 'M', state: 'warning'},
    email: 'mikaela@pexcom.com',
    position: 'Head Of Marketing',
    mobile: '9928000011',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    online: true,
  },
  {
    name: 'Francis Mitcham',
    avatar: 'avatars/300-9.jpg',
    email: 'f.mitcham@kpmg.com.au',
    mobile: '9928000011',
    position: 'Software Arcitect',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    online: false,
  },

  {
    name: 'Olivia Wild',
    initials: {label: 'O', state: 'danger'},
    email: 'olivia@corpmail.com',
    mobile: '9928000011',
    position: 'System Admin',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    online: true,
  },
  {
    name: 'Neil Owen',
    initials: {label: 'N', state: 'primary'},
    email: 'owen.neil@gmail.com',
    mobile: '9928000011',
    position: 'Account Manager',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    online: true,
  },
  {
    name: 'Dan Wilson',
    avatar: 'avatars/300-23.jpg',
    email: 'dam@consilting.com',
    mobile: '9928000011',
    position: 'Web Desinger',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    online: false,
  },
  {
    name: 'Emma Bold',
    initials: {label: 'E', state: 'danger'},
    email: 'emma@intenso.com',
    mobile: '9928000011',
    position: 'Corporate Finance',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    online: true,
  },
  {
    name: 'Ana Crown',
    avatar: 'avatars/300-12.jpg',
    email: 'ana.cf@limtel.com',
    mobile: '9928000011',
    position: 'Customer Relationship',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    online: false,
  },
  {
    name: 'Robert Doe',
    initials: {label: 'A', state: 'info'},
    email: 'robert@benko.com',
    mobile: '9928000011',
    position: 'Marketing Executive',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    online: true,
  },
  {
    name: 'John Miller',
    avatar: 'avatars/300-13.jpg',
    email: 'miller@mapple.com',
    mobile: '9928000011',
    position: 'Project Manager',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    online: false,
  },
  {
    name: 'Lucy Kunic',
    initials: {label: 'L', state: 'success'},
    email: 'lucy.m@fentech.com',
    mobile: '9928000011',
    position: 'SEO Master',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    online: true,
  },
  {
    name: 'Ethan Wilder',
    avatar: 'avatars/300-21.jpg',
    email: 'ethan@loop.com.au',
    mobile: '9928000011',
    position: 'Accountant',
    visiting_center: 'Noida',
    tantative_joining: 'Aug 01, 2024',
    visit_date: 'Aug 01, 2024',
    online: true,
  },
]

const messageFromClient: MessageModel = {
  user: 4,
  type: 'in',
  text: 'Thank you for your awesome support!',
  time: 'Just now',
}

export interface AlertModel {
  title: string
  description: string
  time: string
  icon: string
  state: 'primary' | 'danger' | 'warning' | 'success' | 'info'
}

const defaultAlerts: Array<AlertModel> = [
  {
    title: 'Project Alice',
    description: 'Phase 1 development',
    time: '1 hr',
    icon: 'technology-2',
    state: 'primary',
  },
  {
    title: 'HR Confidential',
    description: 'Confidential staff documents',
    time: '2 hrs',
    icon: 'information-5',
    state: 'danger',
  },
  {
    title: 'Company HR',
    description: 'Corporeate staff profiles',
    time: '5 hrs',
    icon: 'map001',
    state: 'warning',
  },
  {
    title: 'Project Red',
    description: 'New frontend admin theme',
    time: '2 days',
    icon: 'cloud-change',
    state: 'success',
  },
  {
    title: 'Project Breafing',
    description: 'Product launch status update',
    time: '21 Jan',
    icon: 'compass',
    state: 'primary',
  },
  {
    title: 'Banner Assets',
    description: 'Collection of banner images',
    time: '21 Jan',
    icon: 'graph-3',
    state: 'info',
  },
  {
    title: 'Icon Assets',
    description: 'Collection of SVG icons',
    time: '20 March',
    icon: 'color-swatch',
    state: 'warning',
  },
]
export interface LogModel {
  code: string
  state: 'success' | 'danger' | 'warning'
  message: string
  time: string
}

const defaultLogs: Array<LogModel> = [
  {code: '200 OK', state: 'success', message: 'New order', time: 'Just now'},
  {code: '500 ERR', state: 'danger', message: 'New customer', time: '2 hrs'},
  {code: '200 OK', state: 'success', message: 'Payment process', time: '5 hrs'},
  {code: '300 WRN', state: 'warning', message: 'Search query', time: '2 days'},
  {code: '200 OK', state: 'success', message: 'API connection', time: '1 week'},
  {code: '200 OK', state: 'success', message: 'Database restore', time: 'Mar 5'},
  {code: '300 WRN', state: 'warning', message: 'System update', time: 'May 15'},
  {code: '300 WRN', state: 'warning', message: 'Server OS update', time: 'Apr 3'},
  {code: '300 WRN', state: 'warning', message: 'API rollback', time: 'Jun 30'},
  {code: '500 ERR', state: 'danger', message: 'Refund process', time: 'Jul 10'},
  {code: '500 ERR', state: 'danger', message: 'Withdrawal process', time: 'Sep 10'},
  {code: '500 ERR', state: 'danger', message: 'Mail tasks', time: 'Dec 10'},
]

export {defaultMessages, defaultPermissions, defaultUserInfos, defaultAlerts, defaultLogs, messageFromClient}
